const FETCH_MATCHING_PROGRAM = 'bfb/combiners/mentorMatching/FETCH_MATCHING_PROGRAM';
const FETCH_MATCHING_PROGRAM_FAILED = 'bfb/combiners/mentorMatching/FETCH_MATCHING_PROGRAM_FAILED';

export default {
  FETCH_MATCHING_PROGRAM,
  FETCH_MATCHING_PROGRAM_FAILED,
};
